<template>
  <div style="height: 16px;" class="flex align-center">
    <div class="move-container" @mousedown="onChangeStatus">
    </div>
  </div>
</template>

<script>
export default {
  name: 'MoveVertical',
  components: {},
  props: {
    min: { // 拖动最小值
      type: Number,
      default: 100
    },
    max: { // 拖动最大值
      type: Number,
      default: 450
    },
    moveId: {
      type: String,
      default: 'moveTop'
    },
    moveDom: { // top, bottom
      type: String,
      default: 'top'
    }
  },
  data () {
    return {
      startY: 0
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
    onChangeStatus (e) {
      this.startY = e.clientY
      let that = this
      let moveDom = document.getElementById(this.moveId)
      let height = parseFloat(moveDom.style.height)
      document.onmousemove = evt => {
        let moveDistance = evt.clientY - that.startY
        let finalH = height + moveDistance
        if (that.moveDom === 'bottom') {
          finalH = height - moveDistance
        }
        moveDom.style.height = finalH < that.min ? that.min : finalH > that.max ? that.max : finalH + 'px'
      }
      document.onmouseup = function () {
        document.onmousemove = null
        document.onmouseup = null
      }
      return false
    }
  }
}
</script>

<style lang="scss" scoped>
.move-container {
  height: 2px;
  width: 100%;
  background: #e5e5e5;
  position: relative;
  margin: 0 7px;
  &:before {
    content: url("/static/images/yidongshangxia.png");
    width: 30px;
    height: 16px;
    position: absolute;
    left: calc(50% - 15px);
    top: -7px;
  }
  &:hover {
    cursor: n-resize;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MoveVertical.vue